<template>
  <div>
    <div class="panal mt-20">
      <div class="panal-header">Old Request</div>
      <div class="panal-body">

<b-form @submit="onSubmit"  v-if="show">

            
            <div class="row">
        
            <div class="col-12 col-md-6 mb-1">
              

<b-form-group id="input-group-1" label="Request ID:" label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="form.Serial"
          placeholder="Enter name"
          required 
          type="text"
          class="form-control su-border"
        ></b-form-input>
 </b-form-group>

            </div>

             <div class="col-12 col-md-6 mb-1 pt-2">
            
                 <b-button type="submit" variant="primary" class="mt-4" @click="onSubmit">Search</b-button>
                 </div>

            </div>
</b-form>
<div class="divider"></div>
<div v-if="showForm">
  <h2> <b-badge>{{message[0].Name}}</b-badge></h2>
  <p>Request .............</p>

  <div>
  <b-alert show variant="success">
    <h4 class="alert-heading">Request Type :{{message[0].Request_Type}}</h4>
    <p>
    <span class="float-right text-warning">{{message[0].RequestDate}}</span><br/>
   {{ message[0].QuestionText}}
    </p>
    <hr>
    
  </b-alert>
</div>



 <!-- v-if="showForm2"  -->
<div>

 <div class="ml-2" v-for="comm in comment" :key="comm.serial" >
   <div v-if="comm.IsEmployee">
     <p class="text-warning text-bold">Employee  .............</p>
 <b-alert  show variant="primary" >
    <span class="float-right text-warning" >{{comm.StatusDate}}</span><br/>   
   <!-- <span v-if="comm.IsEmployee">Employee</span>
     <span v-else>Student</span>   -->
   
   {{comm.Note}}</b-alert>
   </div>
   <div v-else class="ml-5">
     <p class="text-warning text-bold">{{message[0].Name}}  .............</p>
   <b-alert  show variant="info" >
    <span class="float-right text-warning" >{{comm.StatusDate}}</span><br/>   
   
     
   
   {{comm.Note}}</b-alert>
   </div>
 
   

  <p class="">{{comm.Name}}</p>
 <div class="ml-5">
     
   <!-- <b-alert show variant="info" ><span class="float-right text-warning"> {{comm.StatusDate}}</span><br/>   
    {{comm.Note}}</b-alert> -->

 


 </div> 
 </div>
</div>


</div>


      </div>
    </div>
  </div>
</template>




          <script>
          import EventService from '../../services/Event/event.services';
export default {
  name: "Old Request",
  data() {
    return { 
 comment:'',
 showForm: false,
//  showForm2: false,
        form: {
         
           Serial: '',
           message:'',
         
          
    
      
          
        },
         show: true,
         
          
    };
  },
  methods: {
    onSubmit(e) {
    //   this.$router.push("/event");



 // eslint-disable-next-line no-debugger
           debugger
EventService.IREQ_Request_Select(this.form.Serial).then(Response =>{
          
          this.message=Response.data;

            // eslint-disable-next-line no-console
          //  console.log(Response.data)
          // this.Name=Response.data[0]['Name'];
         
          this.successful =true;
         this.showForm =true;
         

           EventService.GetAllComments(this.form.Serial).then(e =>{
          this.comment=e.data;
          // this.Name=Response.data[0]['Name'];
          //this.successful =true;
          // alert(this.showForm);
        //// this.showForm =true;
        // alert(this.message);
        // alert(this.showForm);
       
     
        }, error => {
          this.empty =false
          this.successful =false
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
               
            }); 
          
     
        }, error => {
          this.empty =false
          this.successful =false
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                 this.$alert("Error, This request id is invalid, please check the request id!");
            }); 


       



    e.preventDefault()
        // alert(JSON.stringify(this.form))





    },
      

     mounted() {
  



  },
  

    }
};
</script>

<style scoped>
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}
table tr th {
  background-color: #4caf5000 !important;
  color: #333;
  font-weight: bold;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}

.divider {
  *width: 100%;
  height: 1px;
  margin: 9px 1px;
  *margin: -5px 0 5px;
  overflow: hidden;
  /* background-color: #e5e5e5; */
  border-bottom: 1px dotted #e5e5e5;
}
.su-border {
  border-color: #3d8fe3 !important;
  background: #f1f9ff !important;
}
.panal-body {
  padding: 20px;
  color: #333;
}
.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}
.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}
.app-All {
  width: 80%;
  float: left;
}
.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;
}
.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-light th {
  font-size: 14px !important;
}
.table .thead-light th {
  font-size: 14px !important;
  background-color: #eaeaea !important;
}

.panal2 {
  background: #eee;
  border-radius: 10px;
  color: #333;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header2 {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body2 {
  padding: 20px;
  color: #333;
}
.mt-10 {
  margin-top: 10px;
}

.btn {
  margin-left: 5px;
}
</style>